module.exports = __webpack_public_path__ + "img/facebook.5574251e.svg";